import { MessageBusService } from "@/other/messageBus/MessageBusService";
import { IApiResult } from "@/uiLibrary/virtualScroll/useSubscription";
import { dateDescendingSortCompare } from "@/uiLibrary/virtualScroll/sorters";

export const INTERNAL_MEDIA_PAGE_SIZE = 10;

type InternalMediaDto =
    RedDeer.InternalMedia.Client.UI.Contracts.Dtos.InternalMediaDto;

export const internalMediaSortCompare =
    dateDescendingSortCompare<InternalMediaDto>(
        x => x.publishedDateTime,
        x => x.id
    );

export function getInternalMediaItemId(item: InternalMediaDto) {
    return item.id;
}

export function subscribeToInternalMedia(
    messageBusService: MessageBusService,
    callback: (response: IApiResult<InternalMediaDto, string>) => void,
    maxItems = INTERNAL_MEDIA_PAGE_SIZE
) {
    const request: RedDeer.InternalMedia.Client.UI.Contracts.Queries.GetAllInternalMediaQuery =
        {
            MessageType: "Queries.GetAllInternalMediaQuery",
            Assembly: "RedDeer.InternalMedia.Client.UI.Contracts",
            maxItems: maxItems
        };

    return messageBusService.asyncSubscribe<RedDeer.InternalMedia.Client.UI.Contracts.Queries.GetAllInternalMediaResponse>(
        {
            request,
            description: "Subscribing to internal media",
            callback
        }
    );
}
